import { useMemo } from 'react';
import styled from '@emotion/styled';
import { emptyObject } from '@constants/empty';
import { Fonts, Spacings } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';
import { KEY_TYPE_MAP } from './RatingChart/utils';
import useRatingProgressInfo from './useRatingProgressInfo';

const Wrapper = styled.div`
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
`;

const InfoContainer = styled.div`
  width: 100%;
  height: 42px;
  border-right: ${({ $hideBorder }) =>
    $hideBorder ? '' : '1px solid var(--color-divider)'};
`;

const InfoType = styled(Typography)`
  text-align: center;
  letter-spacing: 0.02em;
  font-weight: ${Fonts.HEAVY};
  font-size: ${Fonts.EXTRA_SMALL};
  line-height: ${Fonts.EXTRA_SMALL};
  color: var(--color-text-secondary);
`;

const InfoValue = styled(Typography)`
  text-align: center;
  margin-top: ${Spacings.SPACING_2B};
`;

const CompeteInfo = ({ isInsideModal = false }) => {
  const { data } = useRatingProgressInfo();
  const { competeAggregateInfo } = data;

  const infoList = useMemo(() => {
    const list = Object.keys(competeAggregateInfo || emptyObject).map((key) => {
      if (KEY_TYPE_MAP[key]) {
        return {
          infoType: KEY_TYPE_MAP[key].type,
          value: competeAggregateInfo[key],
          pos: KEY_TYPE_MAP[key].pos
        };
      }
      return emptyObject;
    });
    return list.sort((a, b) => a.pos - b.pos);
  }, [competeAggregateInfo]);

  return (
    <Wrapper>
      {infoList.map((info, index) => {
        const isLastItem = index === infoList.length - 1;
        return (
          <InfoContainer
            key={info.infoType}
            $hideBorder={isLastItem || !isInsideModal}
          >
            <InfoType variant="p3">{info.infoType}</InfoType>
            <InfoValue variant="h5">{info.value}</InfoValue>
          </InfoContainer>
        );
      })}
    </Wrapper>
  );
};

export default CompeteInfo;
